import React from "react";
import useAdminListBlogs from "../hooks/useAdminListBlogs";
import useAPI from "../hooks/useAPI";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { blogsActions } from "../state/blogs";

export default function AdminListBlogs(props) {
  const { handleDelete, onEdit, businessType } = useAdminListBlogs(props);

  const dispatch = useDispatch();

  const { data: dataBlogs, query: fetchData } = useAPI({
    type: "get",
    url: `articles`,
  });

  const items = useSelector((state) => state.blogs.blogs);

  const handleRefreshData = async () => {
    await fetchData();
  };

  React.useEffect(() => {
    if (dataBlogs && dataBlogs.data) {
      dispatch(blogsActions.fetchAll(dataBlogs.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataBlogs]);

  const displayedColumns = React.useMemo(() => {
    const baseColumns = [
      { id: "id", label: "ID", minWidth: 50 },
      { id: "title", label: "Titre", minWidth: 200 },
      { id: "tags", label: "Tags", minWidth: 150 },
      { id: "merchants", label: "Points de vente", minWidth: 100 },
      { id: "created", label: "Date", minWidth: 100 },
      { id: "action", label: "Actions", minWidth: isMobile ? 90 : 90 },
    ];
    return baseColumns;
  }, []);

  return (
    <div>
      <StickyHeadTable
        businessType={businessType}
        filters={["id", "title", "tags", "merchants", "created"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "title" || c.id === "action"
              )
            : displayedColumns
        }
        data={items.map((b) => ({
          id: b.id.toString(),
          title: b.title,
          tags: (b.tags || []).join(", "),
          merchants: (b.metadata?.associatedMerchants || []).length.toString(),
          created: new Date(b.created).toLocaleDateString("fr-FR"),
          metadata: b.metadata,
        }))}
        onEdit={onEdit}
        onEdit2={() => {
          console.log("Edit 2 clicked");
        }}
        onRefreshData={handleRefreshData}
        onDelete={handleDelete}
      />
    </div>
  );
}
